<script setup lang="ts">
import type { HouseTruthLink } from 'lc-services/types/common/search'

const { locale } = useI18n()

withDefaults(
  defineProps<{
    houseTruthLinks?: Pick<HouseTruthLink, 'description'>[]
  }>(),
  {
    houseTruthLinks: () => [],
  },
)
</script>

<template>
  <div>
    <h2 class="m-0 mb-2.5 text-2xl">
      {{ $t('house.truthLinks.title') }}
    </h2>

    <ul class="m-0 p-0">
      <li
        v-for="(keypoint, i) in houseTruthLinks"
        :key="i"
        class="mb-4 flex items-center last:mb-0"
      >
        <BaseIcon class="mr-3 flex-none rounded-full bg-beige" name="check" />
        <span>
          {{ keypoint.description[locale] }}
        </span>
      </li>
    </ul>
  </div>
</template>
